<button
  mat-icon-button
  [matMenuTriggerFor]="notificationsMenu"
  class="relative text-pmdf-base-secondary font-light"
  aria-label="Notificações"
  [matTooltip]="connectionTooltip()"
>
  <mat-icon
    [matBadge]="unreadCount() > 0 ? unreadCount().toString() : ''"
    matBadgeColor="warn"
    matBadgeSize="small"
    [matBadgeHidden]="unreadCount() === 0"
    aria-hidden="false"
  >
    {{ bellIcon() }}
  </mat-icon>

  @if (status() === 'monitoring') {
    <span class="absolute bottom-1 right-1 h-2 w-2 rounded-full bg-pmdf-success ring-1 ring-white animate-pulse"></span>
  } @else if (status() === 'push-active' || status() === 'partial') {
    <span class="absolute bottom-1 right-1 h-2 w-2 rounded-full bg-pmdf-success ring-1 ring-white"></span>
  }
</button>

<mat-menu #notificationsMenu="matMenu" class="" xPosition="before">
  <div class="max-h-[600px]" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="p-4 pt-2 flex items-center justify-between">
      <div>
        <h3 class="text-lg font-semibold m-0">Notificações</h3>
        @if (unreadCount() > 0) {
          <p class="text-sm opacity-90 m-0">Você tem {{ unreadCount() }} novas notificações</p>
        } @else {
          <p class="text-sm opacity-70 m-0">Nenhuma notificação nova</p>
        }
      </div>
      <button mat-icon-button (click)="openSettings()" matTooltip="Configurações">
        <mat-icon>settings</mat-icon>
      </button>
    </div>

    <!-- Status bar -->
    @if (status() === 'offline') {
      <div class="mx-4 mb-2 flex items-center gap-2 rounded px-3 py-1.5 bg-pmdf-bg-muted text-pmdf-muted-55">
        <span class="h-2 w-2 rounded-full bg-pmdf-border-strong"></span>
        <span class="text-xs">Sem conexão — ative nas
          <button class="text-pmdf-info underline cursor-pointer" (click)="openSettings()">configurações</button>
        </span>
      </div>
    }

    <!-- Notifications List -->
    <div class="notifications-list overflow-y-auto max-h-[400px]">
      @for (notification of displayNotifications(); track notification.id) {
        <div
          class="notification-item flex items-start gap-3 px-4 py-3 border-b cursor-pointer relative transition-colors hover:bg-pmdf-bg-subtle"
          [class.bg-pmdf-info-soft/40]="!notification.read"
          (click)="openNotification(notification)"
        >
          <!-- Icon -->
          <div class="notification-icon shrink-0">
            <div
              class="flex h-10 w-10 items-center justify-center rounded-full"
              [class]="getPriorityConfig(notification.priority).bgClass"
            >
              <mat-icon
                [class]="getPriorityConfig(notification.priority).colorClass"
              >
                {{ getAlertIcon(notification) }}
              </mat-icon>
            </div>
          </div>

          <!-- Content -->
          <div class="flex-1 min-w-0">
            <div class="flex items-start justify-between gap-2 mb-0.5">
              <h4 class="text-sm font-semibold m-0 truncate">
                {{ notification.summary }}
              </h4>
              @if (!notification.read) {
                <span class="h-2 w-2 rounded-full bg-pmdf-primary shrink-0 mt-1.5"></span>
              }
            </div>

            <!-- Crime type + distance -->
            @if (notification.crimeType) {
              <p class="text-xs text-pmdf-muted-70 m-0 mb-0.5 truncate">{{ notification.crimeType }}</p>
            }

            <div class="flex items-center gap-2 text-xs text-pmdf-muted-55">
              @if (notification.distance.formattedText) {
                <span class="flex items-center gap-0.5">
                  <mat-icon class="icon-xs">place</mat-icon>
                  {{ notification.distance.formattedText }}
                </span>
              }
              <span>{{ notification.elapsedTime || notification.timestamp }}</span>
              <span class="ml-auto rounded px-1.5 py-0.5 text-[10px] font-medium"
                [class]="getPriorityConfig(notification.priority).bgClass + ' ' + getPriorityConfig(notification.priority).colorClass">
                {{ getAlertTypeLabel(notification.alertType) }}
              </span>
            </div>
          </div>

          <!-- Arrow -->
          <mat-icon class="shrink-0 mt-1 text-pmdf-muted-55 icon-sm">chevron_right</mat-icon>

          <!-- Unread indicator (left border) -->
          @if (!notification.read) {
            <div class="absolute left-0 top-0 bottom-0 w-1 bg-accent-primary rounded-r"></div>
          }
        </div>
      }

      @if (displayNotifications().length === 0) {
        <div class="empty-state py-4 text-center">
          <mat-icon class="icon-2xl mb-3 text-pmdf-muted-55">notifications_none</mat-icon>
          <p class="text-sm font-medium m-0 text-pmdf-muted-55">Nenhuma notificação pendente</p>
        </div>
      }
    </div>

    <!-- Footer -->
    @if (unreadCount() > 0) {
      <div class="notifications-footer border-t p-3 text-center">
        <button
          mat-button
          class="font-semibold"
          (click)="markAllAsRead()"
        >
          MARCAR TODAS COMO LIDAS
        </button>
      </div>
    }
  </div>
</mat-menu>
